import { checkoutOptimizationStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { CheckoutTreeOverviewSchema } from "@redotech/redo-model/checkouts/checkout-tree";
import {
  ValidateCheckoutTreeTransformationError,
  ValidateCheckoutTreeTransformationWarning,
} from "@redotech/redo-model/checkouts/checkout-tree-transformation";
import * as z from "zod/v4";

export const validateCheckoutTreeTransformationForNewSplit = {
  name: "validateCheckoutTreeTransformationForNewSplit" as const,
  input: z.object({ flowSteps: checkoutOptimizationStepArraySchema }),
  output: z.object({
    warnings: z.array(ValidateCheckoutTreeTransformationWarning),
    errors: z.array(ValidateCheckoutTreeTransformationError),
    currentCheckoutTreeOverview: CheckoutTreeOverviewSchema.optional(),
    proposedCheckoutTreeOverview: CheckoutTreeOverviewSchema.optional(),
  }),
};
export type ValidateCheckoutTreeTransformationForNewSplitOutput = z.infer<
  typeof validateCheckoutTreeTransformationForNewSplit.output
>;
